module.exports = __webpack_public_path__ + "img/google-logo-mini.cbf2af95.svg";